export default "__VITE_ASSET__82cf2468__"